import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  LogService,
  TOKENS as COMMON_TOKENS,
} from '@trustedshops/tswp-core-common';
import { environment } from '../../environments/environment';
import {
  GetMonthlyReviewsCountGoalResponse,
  GetReviewsCountResponse,
} from '../models/review.interface';
import { ANGULAR_HTTP_CLIENT_TOKEN } from '../angular-http-client.module';

@Injectable()
export class ReviewsService {
  private static readonly TYPE: string = 'ReviewsService';
  private readonly basePath: string = environment.apis.accounts;
  private readonly monthlyReviewCountGoalPath: string =
    environment.apis.monthlyReviewCountGoal;

  public constructor(
    @Inject(COMMON_TOKENS.LogService) private readonly logService: LogService,
    @Inject(ANGULAR_HTTP_CLIENT_TOKEN) private readonly httpClient: HttpClient
  ) {}

  public getReviewsCount(
    params: HttpParams
  ): Observable<GetReviewsCountResponse> {
    return this.httpClient
      .get<GetReviewsCountResponse>(
        `${this.basePath}/reviews-minimal`,{
          params
        }
      )
      .pipe(catchError((error) => {
        this.logService.error(
          ReviewsService.TYPE,
          new Error(`Get Reviews Count has failed: ${JSON.stringify(error)}`)
        );

        return throwError(() => error);
      }));
  }

  public getMonthlyReviewsCountGoal(
    params?: HttpParams
  ): Observable<GetMonthlyReviewsCountGoalResponse> {
    return this.httpClient
      .get<GetMonthlyReviewsCountGoalResponse>(
        `${this.monthlyReviewCountGoalPath}`,
        {
          params
        }
      )
      .pipe(catchError(error => {
        this.logService.error(
          ReviewsService.TYPE,
          new Error(`Get Monthly Reviews Goal has failed: ${JSON.stringify(error)}`)
        );

        return throwError(() => error);
      }));
  }
}
